import {Base} from "../Base";
import {Box, Button, Container, Link, Paper, Stack, TextField} from "@mui/material";
import styled from "styled-components";
import {useContext, useEffect, useState} from "react";
import {PostLogin, GetLoginStatus} from "../api/AuthenticationApi";
import {AppContext} from "../App";

const NoteText = styled.span`
font-size:0.9em;`

export const LoginPage = () => {

  const [mail, setMail] = useState<string>("")
  const [pass, setPass] = useState<string>("")
  const { dispatch } = useContext(AppContext);

  const checkAlreadyLogin = async () => {
    // フロント側では正確なログイン判定が難しいため、専用 API で確認する
    const { loggedIn, redirectTo } = await GetLoginStatus();
    if (loggedIn) {
      window.location.href = redirectTo;
    }
  };

  const handleLoginButtonClick = async () => {
    try {
      const redirectTo = await PostLogin(mail, pass);
      window.location.href = redirectTo;
    } catch (e: any) {
      dispatch({ type: "setError", payload: { error: true, message: e.message } });
    }
  };

  useEffect(() => {
    checkAlreadyLogin();
  }, [])

  return <Base>
    <Paper>
      <Container maxWidth={"sm"}>
        <Box p={1}>
          <TextField variant={"standard"} label={"メールアドレス"} value={mail} onChange={e => setMail(e.target.value)}
                     fullWidth/>
        </Box>
        <Box p={1}>
          <TextField variant={"standard"} label={"パスワード"} type={"password"} value={pass}
                     onChange={e => setPass(e.target.value)}
                     fullWidth/>
        </Box>
        <Box p={1} display={"flex"} justifyContent={"center"}>
          <Button variant={"contained"} onClick={handleLoginButtonClick}>ログイン</Button>
        </Box>
        <Stack p={1} direction={"row"} spacing={1} display={"flex"} justifyContent={"center"}>
          <Link href={"/register"}><NoteText>新しいアカウントを作成</NoteText></Link>
          <Link href={"/password"}><NoteText>パスワードを忘れた場合</NoteText></Link>
        </Stack>
      </Container>
    </Paper>
  </Base>
}